module.exports = __webpack_public_path__ + "img/Unipod-logo.016fe425.png";